module.exports = __webpack_public_path__ + "img/filter-type-arms.bcdc7b2b.svg";